import { render, staticRenderFns } from "./Prequiz.vue?vue&type=template&id=66b2e8d0&scoped=true"
import script from "./Prequiz.vue?vue&type=script&lang=js"
export * from "./Prequiz.vue?vue&type=script&lang=js"
import style0 from "./Prequiz.vue?vue&type=style&index=0&id=66b2e8d0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b2e8d0",
  null
  
)

export default component.exports